import SubcontractorAdhocFeeCreate from "./SubcontractorAdhocFeeCreate";
import SubcontractorAdhocFeeList from "./SubcontractorAdhocFeeList";
import SubcontractorAdhocFeeEdit from "./SubcontractorAdhocFeeEdit";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "subcontractorAdhocFees",
  create: SubcontractorAdhocFeeCreate,
  list: SubcontractorAdhocFeeList,
  edit: SubcontractorAdhocFeeEdit,
};
